// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPayor {
    static getAttributeTypeMap() {
        return PharmacyBiPayor.attributeTypeMap;
    }
}
PharmacyBiPayor.discriminator = undefined;
PharmacyBiPayor.additionalProperties = false;
PharmacyBiPayor.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "cardHolderId",
        "baseName": "cardHolderId",
        "type": "string"
    },
    {
        "name": "groupId",
        "baseName": "groupId",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPayor.js.map